import React from 'react';
import '../components/MainPage/ServiceCards.css';

const services = [
  {
    name: 'Веб-разработка',
    text: 'Создаём веб-сервисы для клиентов и сотрудников: от пользовательского интерфейса до серверной логики.',
    stack: [
      ['React', 'Vue', 'Angular', 'TypeScript'],
      ['ASP.NET Core', 'C#', 'Web API', 'EF Core'],
    ],
  },
  {
    name: 'Мобильные приложения',
    text: 'Разрабатываем приложения для iOS и Android. Выбираем нативный или кроссплатформенный подход под задачу.',
    stack: [['Flutter', 'React Native', 'Swift', 'Kotlin']],
  },
  {
    name: 'CRM-системы',
    text: 'Адаптируем CRM под вашу работу с клиентами: настраиваем процессы и добавляем необходимые функции.',
    stack: [['MS Dynamics 365', 'BPMSoft', 'Creatio']],
  },
  {
    name: 'Интеграции и данные',
    text: 'Настраиваем обмен данными между системами компании и внешними сервисами — от DaData и ЕСИА до корпоративных платформ.',
    stack: [['REST', 'SOAP', 'GraphQL', 'Kafka', 'RabbitMQ', 'IBM MQ', 'PostgreSQL', 'MSSQL', 'Oracle', 'Redis', 'Docker', 'k8s', 'CI/CD']],
  },
];

const HardSkillsPage: React.FC = () => (
  <section
    aria-labelledby="engineering-title"
    className="engineering-section section-space"
    id="HardSkills"
  >
    <div className="landing-container">
      <div
        className="section-heading"
        data-flow-reveal
      >
        <p className="eyebrow">
          <span className="section-index">02 /</span>
          {' '}
          РАЗРАБОТКА
        </p>
        <div className="heading-columns">
          <h2 id="engineering-title">
            Сервисы и приложения.
            <br />
            <span className="muted-title">Под ваши процессы.</span>
          </h2>
          <p>
            В команде — инженеры с опытом более 10 лет для разработки и экспертной поддержки вашего проекта.
          </p>
        </div>
      </div>
      <div
        className="engineering-cards"
        data-flow-reveal
      >
        {services.map((service) => (
          <article
            key={service.name}
            className="engineering-card"
          >
            <div className="engineering-card-heading">
              <h3>{service.name}</h3>
            </div>
            <p className="engineering-card-description">{service.text}</p>
            <p className="engineering-card-stack">
              {service.stack.map((row) => <span key={row.join('-')}>{row.join(' · ')}</span>)}
            </p>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default HardSkillsPage;
